import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { API } from 'src/app/configs';
import { HttpService } from 'src/app/core/http/http.service';
import { GeneralService } from './general.service';
import { FollowService } from './follow.service'; 
import { headingDistanceTo } from 'geolocation-utils';

@Injectable({
  providedIn: 'root',
  
})
export class AdSearchService implements OnDestroy {

  private adType = {
    1: 'building',
    2: 'properties',
    3: 'ground',
    4: 'vehicles',
    5: 'allotment'
  }

  filterTypes = [
    { id: 1, value: ['1','5'], title: 'Empreendimentos' },
    { id: 2, value: ['2','3','4'], title: 'De terceiros'}
  ];

  private filterMatchOptions: any = {
    ad: [
        { id: 'recent-updated', title: 'Atualização recente', default: true }
      , { id: 'recent-published', title: 'Publicação recente' }
      //, { id: 'best-match', title: 'Mais relevantes' }
      , { id: 'low-price', title: 'Menores preços' }
      , { id: 'high-price', title: 'Maiores preços' }
    ],
    person: [
        { id: 'recent-published', title: 'Publicação recente' }
      , { id: 'alphabetical', title: 'Ordem alfabética', default: true }
      , { id: 'recent', title: 'Empresas recentes' }
      , { id: 'published', title: 'Quantidade de anúncios' }
      //, { id: 'followers', title: 'Quantidade de usuários que adicionaram à favoritos' }
    ]
  };


  numLoading = {
    ad : 20,
    person : 20
  };

  protected filterGroup = 'ad';

  public filterMatchSelected = {
    'ad' : null,
    'person' : null
  };

  private cache = {
    ad : [],
    person : []
  };

  private componentData = [];

  public source = null;

  private filterSelectedSubject = new BehaviorSubject<any>([]);
  filterSelected$ = this.filterSelectedSubject.asObservable();

  private filterSubject = new BehaviorSubject<any>([]);
  filter$ = this.filterSubject.asObservable();

  private adsSubject = new BehaviorSubject<any>([]);
  ads$ = this.adsSubject.asObservable();

  private personsSubject = new BehaviorSubject<any>([]);
  persons$ = this.personsSubject.asObservable();

  private searchsSubject = new BehaviorSubject<any>([]);
  searchs$ = this.searchsSubject.asObservable();

  public type = '';

  private filtersSelected: any = { ad : {data: []}, person: {data :[]} };

  protected personDataSubscription: Subscription;

  public cityMain = null;

  public filterProperties = {
    person: {
      city: {
        //unique:true,
        data: [],
        list: []
      },
      perfil: {
        data: [],
        list: [
          { id: 4, name: 'Construtora / Incorporadora'},
          { id: 6, name: 'Imobiliária', realestateType : true  },
          { id: 5, name: 'Autônomo', realtorType : true }
        ]
      },
      title : {
        fill: true,
        data : ''
      }
    },
    ad: {
      title : {
        fill: true,
        data : ''
      },
      owner : {
        fill: true,
        data : ''
      },
      amount: {
        fill: true,
        min: 20000,
        max: 5000000,
        step: 20000
      },
      area: {
        fill: true,
        min: 20000,
        max: 5000000,
        step: 20000
      },
      city: { 
        data: [],
        list: []
      },
      district : {
        fill: true,
        data : ''
      }
      , status: { 
        data: []
      }
      , typeAd: { 
        title : 'Seção',
        default:true,
        data: this.filterTypes,
        //send : true
      }
      , exclusive: { 
        title : 'Exclusivos',
        //send : true
      }
      , type: {   
          unique: true,
          sameParent : true,
          data: []
        }
      , delivery: {   
          unique: true,
          data: []
        }
      , room: {
        unique: true,
        allow: {
          type: [28,29,138]
        }
        , data: [
          { id: 1, name: '1' },
          { id: 2, name: '2' },
          { id: 3, name: '3' },
          { id: 4, name: '4' },
          { id: 5, name: '5' }
        ]
      }
      , bathroom: {
        unique: true,
        allow: {
          type: [28,29,138,30,139]
        }
        , data: [
          { id: 1, name: '1' },
          { id: 2, name: '2' },
          { id: 3, name: '3' },
          { id: 4, name: '4' },
          { id: 5, name: '5' }
        ]
      }
      , suite: {
        unique: true,
        allow: {
          type: [28,29,138]
        }
        , data: [
          { id: 1, name: '1' },
          { id: 2, name: '2' },
          { id: 3, name: '3' },
          { id: 4, name: '4' },
          { id: 5, name: '5' }
        ]
      }
      , garage: {
        unique: true,
        allow: {
          type: [28,29,138,30,139]
        }
        , data: [
          { id: 1, name: '1' },
          { id: 2, name: '2' },
          { id: 3, name: '3' },
          { id: 4, name: '4' },
          { id: 5, name: '5' }
        ]
      }
    }
  };


  constructor(
    private httpService: HttpService,
    private gs: GeneralService,
    protected fs: FollowService) {

      this.personDataSubscription = this.gs.generalData$.subscribe((result) => {
        if(result?.cities){
          this.adjustCities(result.cities || [], result?.person[0], result.adCities?.states?.buckets || []);
        }

        if(result?.numLoading)
          this.numLoading = result.numLoading;

        if(result?.adFeatures?.ad_category){
          let nTypes = [];
          JSON.parse(JSON.stringify(result.adFeatures.ad_category)).map(item => {
            if(!!item?.items?.length)
              nTypes = [...nTypes,...[item],...item.items];
          });
          nTypes = nTypes.map(item => {
            if(item?.tag_id){
              item.id = parseInt(item.tag_id);
              item.type_id = parseInt(item.type_id);
              //if(item.id == 28)                item.default = true;
              
              item.resultType = ([1,2,3].indexOf(item.type_id) > -1)? ['list','map'] : ['list'];
            }
            return item;
          }).sort((a,b) => a?.sort - b?.sort);

          this.filterProperties.ad.type.data = nTypes; 
        }

        this.filterProperties.person.perfil.list = this.filterProperties.person.perfil.list.filter(item => (!item?.realestateType && !item?.realtorType) || (item?.realestateType && item.realestateType == result?.modules?.realestateType) || (item?.realtorType && item.realtorType == result?.modules?.realtorType));
        
        if(result?.tags?.featureStatus)
          this.filterProperties.ad.status.data = JSON.parse(JSON.stringify(result?.tags?.featureStatus)).map(item => {
            item.id = parseInt(item.tag_id); 
            item.name = item.tag;
            let type = [];
            let typeId = result?.adFeatures?.ad_type?.filter(type => item.type.indexOf(type.type) > -1).map(type => parseInt(type.id)) || [];
            this.filterProperties.ad.type.data.map(t =>{
              if(typeId.indexOf(t.type_id) > -1)
                type.push(t.id);
            })
            item.allow = {type : type};

            return item;
          });
      });
      
    this.setFilterMatchSelected(false, true);   

    this.setDeliveryData();
  }

  getFilterGroup(){
    return this.filterGroup || 'ad';
  }

  setDeliveryData(){
    const date = new Date();
    const currentYear = date.getFullYear();

    this.filterProperties.ad.delivery.data = [
      { id : currentYear+'-'+date.getMonth()+'-'+date.getDate(), name: 'Entregue'},
      date < new Date(currentYear+'-06-30')? { id : currentYear+'-06-30', name: '1° semestre deste ano'} : false,
      { id : currentYear+'-12-31', name: 'Até o final deste ano'},
      { id : (currentYear+1)+'-06-30', name: '1° semestre do ano que vem'},
      { id : (currentYear+1)+'-12-31', name: (currentYear+1)},
      { id : (currentYear+2)+'-12-31', name: (currentYear+2)},
      { id : (currentYear+3)+'-12-31', name: (currentYear+3)},
      { id : (currentYear+4)+'-12-31', name: (currentYear+4)}
    ].filter(Boolean);

  }

  protected adjustCities(cities,person, adCities){

    let lat = person?.address_latitude || false;
    let lon = person?.address_longitude || false;
    let personLocation = {lat: parseFloat(lat), lon : parseFloat(lon)};

    if(typeof person?.cities == 'string')
      person.cities = JSON.parse(person.cities);

    let cityMain = person?.cities?.filter(fc => fc.main)[0] || false;
    let list = [];
    cities.map(item => {
      let cityLocation = {lat: parseFloat(item.lat), lon : parseFloat(item.lon)};

      item.headingDistance = headingDistanceTo(personLocation, cityLocation);
      
      let state = adCities.filter(state => state.key == item.state)[0];
      item.distance = item.headingDistance.distance;
      item.id = item.city_id;
      item.name = item.city;
      item.filter = item.city.toLowerCase();

      if(cityMain.city_id == item.city_id){
        this.cityMain = item;
        item.default = true;
      }
      item.count = state.cities.buckets.filter(city => city.key == item.city)[0]?.doc_count || 0;

      if(!!person?.cities?.filter(fc => fc.city_id == item.city_id).length)
        item.default = true;

      if(list[list?.length-1]?.state!=item.state)
        list.push({state:item.state, parent:true, count:state?.doc_count || 0, filter:item.state.toLowerCase(), cities : []});

      list.filter(state => state.state == item.state)[0].cities.push(item);

      return item;
    });

    let nlist = [];
    list.map(state => {
      state.cities = state.cities.sort((a,b) => lat? a.distance - b.distance : b?.count - a?.count);
      return state;
    }).sort((a,b) => lat? a.cities[0].distance - b.cities[0].distance : b?.count - a?.count).map(state => {
      nlist.push(state)
      nlist = nlist.concat(state.cities);
    });

    this.filterProperties.person.city.data = this.filterProperties.ad.city.data = cities;
    this.filterProperties.person.city.list = this.filterProperties.ad.city.list = nlist;
   
  }

  ngOnDestroy(){
    if (this.personDataSubscription)
      this.personDataSubscription.unsubscribe();
  }

  setFilterGroup(group, matchDefault = false){
    this.filterGroup = group; 
    if(matchDefault)
      this.setFilterMatchSelected(false, true);
  }

  setFilterMatchSelected(id, matchDefault = false){

    this.filterMatchSelected[this.filterGroup] = matchDefault? this.filterMatchOptions[this.filterGroup].filter(item => item?.default)[0] : id;
  }


  setViewComponentData(data) {
    this.componentData = data;
  }

  getViewComponentData() {
    return this.componentData;
  }

  action(event, action, id, options: any = {}) {

    //event.stopPropagation();
    switch (action) {
      case 'q-view':
        this.gs.setLocation('/view/' + id);
        this.setViewComponentData({ loadingAd: id, action: action });
        break;
      case 'view':
        //this.gs.navigate([this.gs.getBase(), 'view', id]);
        this.gs.navigate(['openModal', 'ViewComponentAd', id]);
        break;
      case 'owner':
        this.gs.navigate(['openModal', 'ViewComponentPerson', id]);
        break;
      case 'goTo': //TODO
        return this.gs.goTo([id], null, { ...options, noRouter: true });
        break;
    }
  }

  async loadResult(type, attr: any = {}, formType = null) {
    let numLoading = this.numLoading[this.filterGroup] || attr?.numLoading || attr?.size || 6;
    let result: any = { attr: attr, list: {} };
    
    let url = this.gs.getRouter().url;

    if (formType && url.indexOf(this.gs.getBase()+'/'+formType) == -1 && (!attr?.resultType || url.indexOf(attr?.resultType) == -1)){
      return this.gs.goTo([this.gs.getBase(), formType, attr?.resultType || null], null, { current: true });
    }

    // pre-loading
    if(attr.resultType == 'list'){
      result.list.hits = Array(numLoading).fill({ loading: true });
      this.setResult(type, { ...result, loading: true });
    }

    // loading results
    return await this.httpService.post<any>(API[this.filterGroup].general['search'+attr.resultType], result.attr) 
      .then(result => {
        result.attr = attr;
        this.setResult(type, result);
      })
      .catch((err) => this.gs.error(err));
  }

  async loadAd<T>(id: any, attr:any = {}): Promise<any> {
    
    if(attr.resultType == 'person')
      attr['owner.'+(typeof id ==  'string'? 'friendlyName' : 'personId')] = id;
    else
      attr.friendlyTitle = id;

    return await this.httpService.post(API[attr?.resultType || this.getFilterGroup()].general.searchview, attr)
      .then(result => {
        result['id'] = id;
        return this.setResult(attr?.resultType || this.getFilterGroup(), result);
      })
      .catch((err) => this.gs.error(err));
  }

  getResult(){
    return this.getSubjectValue();
  }


  getSubjectValue(type = this.filterGroup){
    switch(type){
      case 'ad':
        return this.adsSubject.getValue();
      case 'person':
        return this.personsSubject.getValue();
    }
  }

  setSubjectValue(type, value){
    switch(type){
      case 'ad':
        this.adsSubject.next(value);
      break;
      case 'person':
        this.personsSubject.next(value);
      break;
    }
  }

  setCache(type, id, data){
    this.cache[type][id] = data;
  }

  getCache(type, id){
    return this.cache[type][id];
  }

  setResult(type, result: any = {}, update = true, filterGroup = this.filterGroup) {
        switch (type) {
          case 'pre-search':
            this.searchsSubject.next(result);
            return result;
            break;
            case 'person':
              if(result?.person?.length>0){
                result = {...result, ...result.person[0]};
                delete result.person;
              }
              if(result?.addressCity){
                let address = {
                  street : result?.addressStreet,
                  number : result?.addressNumber,
                  city : result?.addressCity,
                  cityId : result?.addressCityId,
                  complement : result?.addressComplement,
                  country : result?.addressCountry,
                  countryId : result?.addressCountryId,
                  district : result?.addressDistrict,
                  state : result?.addressState,
                  stateId : result?.addressStateId
                }
                result.address = address;
      
                delete result.addressStreet;
                delete result.addressNumber;
                delete result.addressCity;
                delete result.addressCityId;
                delete result.addressComplement;
                delete result.addressCountry;
                delete result.addressCountryId;
                delete result.addressDistrict;
                delete result.addressState;
                delete result.addressStateId;
              }
              this.setCache(type, result.id, result);
              
              //if(update)          this.setSubjectValue(type,result);
      
              if(result?.ads?.list?.hits?.hits?.length > 0)
                result?.ads?.list?.hits?.hits?.map(item => this.setResult('ad',item));
      
              return result;
            break;
          case 'ad':
            let id = result?._source?.friendlyTitle || result.id;
            let data = result?._source? 
              { ...result?._source, inner_hits: result?.inner_hits } :
              (result?.view)? result.view.hits.hits[0]?._source : { ...result.hits.hits[0]?._source, inner_hits: result.hits.hits[0]?.inner_hits };

            this.setCache(type, id, data);

            //if(update)          this.setSubjectValue(type,result);
            return result;
          break;
          default:
            let subjectValue = this.getSubjectValue();
            let nV: any = {};
            if (result?.loading){
              nV = result;
            }
    
            if (result?.pins?.hits){
              nV.pins = result.pins;
            }
            
            if (result?.list && !result?.loading) {
              
            
    
              if((!!subjectValue?.list?.hits?.length || !!subjectValue?.list?.length) && result?.attr?.from > 0){
                nV.list = subjectValue.list;
                nV.list.hits = nV.list.hits.concat(result.list?.hits?.hits || result.list?.hits || result.list).filter(item => !item?.loading);
              } else {
                nV.list = result.list?.hits || {hits : result.list, total : result?.total};
              }
    
              nV.attr = result?.attr || {};
              nV.loading = result?.loading || false;
    
              if (!nV.loading && result.list?.hits?.total)
                nV.list.total = result.list.hits.total;          
            }
    
            if (!nV?.loading && !!nV?.list?.hits?.length)       
              nV.list.hits = nV.list.hits.filter(item => !item?.loading);
              
            if(!result?.loading)
              this.setSubjectValue(filterGroup, nV);
            return result;
            break;
        }
      }

  setResultsCache(result, type){

    result?.map(item => {
      let data = item?._source || item;
      let id = data?.friendlyTitle || data?.id;
      this.cache[type][id] = {...data, ...(typeof this.cache[type][id] !='undefined'? this.cache[type][id] : {})};
    });

  }

  getHitByFriendly(id,type, updateDate = null) {
    if (id === null)
      return {};

    if (typeof this.cache[type] !== 'undefined' && typeof this.cache[type][id] !== 'undefined' && !this.cache[type][id]?.ownerAvatar && this.cache[type][id]?.owner?.avatar){
      this.cache[type][id].ownerAvatar = this.gs.getAvatarFile(this.cache[type][id].owner.avatar);
    }

    if (typeof this.cache[type] !== 'undefined' && typeof this.cache[type][id] !== 'undefined'){
      if(this.cache[type][id]?.update !== updateDate && updateDate!==null)
        return {};

      let cd:Date = this.cache[type][id]?.cacheDate;
      let ad:Date = new Date();
      if(cd && Math.abs(ad.getMinutes() - cd.getMinutes()) > 0)
        return {};

      return this.cache[type][id];
    }

    if (this.getSubjectValue(type)?.list && type == 'ad') {
      let data = this.getSubjectValue(type)?.list.hits.filter(item => item?._source?.friendlyTitle == id);
      return this.cache[type][id] = !data.length ? {} : { ...data[0]._source, inner_hits: data[0].inner_hits};
    }

    return {};
  }

  /*
  getHitByFriendly(id,type) {
    if (id === null)
      return {};

    if (typeof this.cache[type] !== 'undefined' && typeof this.cache[type][id] !== 'undefined' && !this.cache[type][id]?.ownerAvatar && this.cache[type][id]?.owner?.avatar){
      this.cache[type][id].ownerAvatar = this.gs.getAvatarFile(this.cache[type][id].owner.avatar);
    }

    if (typeof this.cache[type] !== 'undefined' && typeof this.cache[type][id] !== 'undefined')
      return this.cache[type][id];

    if (this.getSubjectValue(type)?.list && type == 'ad') {
      
      let data = this.getSubjectValue(type)?.list.hits.filter(item => item?._source?.friendlyTitle == id);
      return this.cache[type][id] = !data.length ? {} : { ...data[0]._source, inner_hits: data[0].inner_hits};
    }

    return {};
  }*/

  getAdType(id) {
    return this.adType[id];
  }

  getDefaultDataFilter(){
    let r= {};
    Object.entries(this.filterProperties[this.filterGroup]).forEach(([key, value]) => {
      if(typeof value['data'] !== 'undefined' && value['data'] instanceof Array)
        Object.entries(value['data']).forEach(([k2, v2]) => {
          if (v2['default'])
            typeof r[key] == 'undefined'? r[key] = [v2] : r[key].push(v2);            
        });
    });
    return r;
  }

  initDataFilter(){
    Object.entries(this.filterProperties[this.filterGroup]).forEach(([key, value]) => {
      if(typeof value['data'] !== 'undefined' && value['data'] instanceof Array)
        Object.entries(value['data']).forEach(([k2, v2]) => {
          if (v2['default'] && this.getFilter(key) === false)
            this.setFilter(v2, key, value);
        });
    });
  }

  getProperties(){
    return this.filterProperties[this.filterGroup] || {};
  }



  //        FILTER

  clearFilter(notClear = []){
    Object.entries(this.filterProperties[this.filterGroup]).forEach(([key, value]) => {
      if(notClear.indexOf(key) == -1)
        this.setFilter(false, key, value);
    });

    this.filterSubject.next('clear');
  }
  setFilter(id, group: any = false, attr: any = {}, add = null) {
    
    let r = this._setFilter(id, group, attr, add);
    
    if(attr?.clear)
      this.filterSelectedSubject.next('clear');
      
    this.filterSelectedSubject.next({selected: this.filtersSelected[this.filterGroup], group : group, id : id});
    return r;
  }
  _setFilter(id, group: any = false, attr: any = {}, add = null) {

    if (group == 'page') {

      let results = this.getSubjectValue()?.list;
      let numLoading = attr?.numLoading;
      switch (id) {
        case 'next':
          if (!results?.total?.value || results.hits.length >= results?.total?.value)
            return false;

          id = results.hits.length;//Math.ceil(results.hits.length / (attr?.numLoading || 6)) + 1;

          let pp = results?.total?.value - results.hits.length + 1;
          numLoading = pp < numLoading ? pp : numLoading;

          break;
      }

      id = { from: id, numLoading: numLoading };
      attr.fill = true;
    }

    if(group == 'city'){
    //  this.setFilter(false, 'geolocation', attr);
    }
    if(group == 'type'){

    }
    
    if (!group)
      return this.filtersSelected[this.filterGroup] = { ...id, data: this.filtersSelected[this.filterGroup]?.data };

    if (id === false){
      if(this.filtersSelected[this.filterGroup]?.data[group])
        delete this.filtersSelected[this.filterGroup].data[group];

      return this.filtersSelected[this.filterGroup];
    }

    if (attr?.fill)
      return this.filtersSelected[this.filterGroup].data[group] = id instanceof Array? id : [id];

    if (typeof this.filtersSelected[this.filterGroup]?.data[group] == 'undefined')
      this.filtersSelected[this.filterGroup].data[group] = [];

    if (attr?.unique)
      return this.filtersSelected[this.filterGroup].data[group] = (!!this.filtersSelected[this.filterGroup]?.data[group]?.filter(item => item.id == id.id).length) && add === null? [] : [id];

    if (!this.getFilter(group, id))
      this.filtersSelected[this.filterGroup]?.data[group].push({ ...id });
    else if (add === null)
      this.filtersSelected[this.filterGroup].data[group] = this.filtersSelected[this.filterGroup]?.data[group].filter(item => item.id !== id.id);

  }

  getFilter(group: any = 'all', id: any = false) {

    if (group == 'all')
      return this.filtersSelected[this.filterGroup];

    if (group == 'filterMatchOptions')
      return this.filterMatchOptions[this.filterGroup];

      if (group == 'filterMatchSelected')
      return this.filterMatchSelected[this.filterGroup];

    if (group instanceof Array && id == false) {
      return Object.keys(this.filtersSelected[this.filterGroup]?.data).filter(k => group.indexOf(k) > -1).reduce((obj, key) => { obj[key] = this.filtersSelected[this.filterGroup]?.data[key]; return obj; }, {});
    }

    if (!this.filtersSelected[this.filterGroup]?.data[group])
      return false;

    if (id == false)
      return !this.filtersSelected[this.filterGroup]?.data[group] ? false : this.filtersSelected[this.filterGroup]?.data[group];

    if (typeof id === 'string')
      return !!this.filtersSelected[this.filterGroup]?.data[group].filter(item => item[id] == true).length;

    return !!this.filtersSelected[this.filterGroup]?.data[group].filter(item => id instanceof Array ? id.indexOf(item.id) > -1 : item.id === id?.id).length;
  }

  applyFilter(page: any = 1):Promise<any> {
    if (!this.filtersSelected[this.filterGroup]?.data)
      return;

    let attrs = { ...this.filtersSelected[this.filterGroup] };
    delete attrs.data;

    attrs['filterMatch'] = this.filterMatchSelected[this.filterGroup]?.id;

    let filters = this.filtersSelected[this.filterGroup]?.data;

    //if(filters['resultType']?.length > 0 && filters['resultType'][0] == 'map' && filters.city?.length > 1)      filters['resultType'][0]='list';

    Object.entries(filters).forEach(([k, v]) => {
      switch (k) {
        case 'page':        attrs['from'] = v[0]['from'];
                            attrs['size'] = v[0]['numLoading'] || this.numLoading[this.filterGroup];

        break;
        case 'city':        if(((filters['resultType']?.length > 0 && filters['resultType'][0]=='list')/* || !filters?.geolocation*/) && !!Object.values(v).map(item => item?.id).filter(Boolean).length) 
                              attrs['address.cityId'] = Object.values(v).map(item => item.id).filter(Boolean); 

                            if(filters['resultType']?.length == 1 && filters['resultType'][0]=='map' && !v[0]?.centered && v[0] && v[0]?.lat){
                              attrs['address.boxlocations'] = { center : {lat:v[0].lat, lon:v[0].lon}}; 
                            }

                            break;
        case 'district':    if(v[0]?.length > 0) attrs['address.district'] = v[0]; break;
        //case 'city':        if(!!Object.values(v).length) attrs['address.cityId'] = Object.values(v).map(item => item.id); break;
        case 'type':        if(!!Object.values(v).length) attrs['units.typeId'] = Object.values(v).map(item => item.id); break;
        case 'status':      if(!!Object.values(v).length) attrs['featureStatus'] = Object.values(v).map(item => item.id); break;
        case 'category':    if(!!Object.values(v).length) attrs['category'] = Object.values(v).map(item => item.id); break;
        case 'room':        if(v[0]?.id) attrs['units.room'] = v[0]?.id;break;//{ "gte": v[0]?.id }; break;
        case 'bathroom':    if(v[0]?.id) attrs['units.bathroom'] = v[0]?.id;break;//{ "gte": v[0]?.id }; break;
        case 'suite':       if(v[0]?.id) attrs['units.suite'] = v[0]?.id;break;//{ "gte": v[0]?.id }; break;
        case 'garage':      if(v[0]?.id) attrs['units.garage'] = v[0]?.id;break;//{ "gte": v[0]?.id }; break;
        case 'amount':      if(v[0] && v[1] && v[0] !== null && v[1] !== null) attrs['units.amount'] = { "gte": v[0], "lte": v[1] }; 
                            if(v[0] && !v[1] && v[0] !== null) attrs['units.amount'] = { "gte": v[0]}; 
                            if(!v[0] && v[1] && v[1] !== null) attrs['units.amount'] = { "lte": v[1]}; 

                            break;
        case 'area':        if(v[0] && v[1] && v[0] !== null && v[1] !== null) attrs['units.privateArea'] = { "gte": v[0], "lte": v[1] }; 
                            if(v[0] && !v[1] && v[0] !== null) attrs['units.privateArea'] = { "gte": v[0]}; 
                            if(!v[0] && v[1] && v[1] !== null) attrs['units.privateArea'] = { "lte": v[1]}; 

                            break;
        case 'geolocation': if(filters['resultType'][0]=='map'){
                              attrs['address.boxlocations'] = v[0]; 

                              if(!v[0]?.center && typeof attrs['address.cityId'] !=='undefined')
                                delete attrs['address.cityId'];
                            }
                            break;
        case 'resultType':  attrs['resultType'] = v[0]; break;// (!!this.filterProperties[this.filterGroup]?.type?.data?.filter(item => !!filters['type']?.filter(fi => fi.id == item.id).length && item?.resultType.indexOf(v[0]) > -1).length)? v[0] : 'list'; break;
        case 'typeAd':      if(Object.values(v)?.length > 0) attrs['typeId'] = [].concat.apply([], Object.values(v).map(item => item.value).filter(Boolean)); break;
        case 'title':       if(v[0]?.length > 0){
                              attrs['title'] = v[0]; 

                              if(this.filterGroup == 'ad'){
                                attrs['owner.personName'] = attrs['address.street'] = attrs['address.district'] = attrs['address.city'] = v[0]; 
                              }
                            }
                            
                            break;
        case 'delivery':    if(v[0]?.id) attrs['units.endDate'] = {"lte":v[0].id}; break;
        
        case 'exclusive':   if(v[0]) attrs['exclusive'] = true; break;
        case 'perfil':      if(!!Object.values(v).map(item => item.id).filter(Boolean).length) attrs['owner.perfilId'] = Object.values(v).map(item => item.id).filter(Boolean); break;
        case 'owner':       if(v[0]?.length > 0) attrs['owner.personName'] = v[0]; break;

        default:            attrs[k] = v; break;
      }
    });

    if(attrs?.resultType == 'map' && attrs['address.cityId']?.length > 1)
      attrs.resultType = 'list';

    this.filterSubject.next({...attrs, filterGroup:this.filterGroup});
    
    if(typeof attrs['address.boxlocations'] == 'undefined' || !attrs['address.boxlocations']?.center){
      return this.loadResult('search', attrs, this.source);
    }
  }
}
